angular.module('tgaAdmin').controller('HubAchievementsController', [
  '$scope',
  '$state',
  '$filter',
  '$location',
  '$uibModal',
  'hubService',
  '$translate',
  function ($scope, $state, $filter, $location, $uibModal, hubService, $translate) {
    $scope.showBack = $state.current.data.back;

    $scope.data = {
      alerts: [],
      hubId: $state.params.hub_id || null,
    };

    $scope.viewmodel = {
      hub_id: $state.params.hub_id,
      achievements_enabled: false,
      achievements: [],
    };

    $scope.initialize = function () {
      $scope.loading = true;

      hubService.getHub($scope.data.hubId).then((hub) => {
        $scope.viewmodel = { ...$scope.viewmodel, ...hub };
        $scope.viewmodel.achievements.forEach((badge) => {
          badge.enabled = !!badge.enabled;
          return badge;
        });

        $scope.title = `<span class="text-muted">Arcades / ${hub.name} /</span> Achievements`;
        $scope.loading = false;
      });
    };

    $scope.actions = {
      submit(form) {
        $scope.submitted = true;

        $scope.data.alerts = [];

        if (form.$invalid) {
          $scope.actions.createAlert(
            `<span class="fa fa-exclamation-triangle"></span> ${$translate
              .instant('common.check_form_for_errors')
              .toString()}`,
            'danger',
          );
          return;
        }

        $scope.processing = true;

        hubService
          .updateHub($scope.viewmodel)
          .then(
            () => {
              $scope.actions.createAlert('<span class="fa fa-check"></span> Arcade updated.', 'success');
              $state.reload('v1.hub.achievements');
            },
            (error) => {
              $scope.actions.createAlert(
                `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                'danger',
              );
            },
          )
          .finally(() => {
            $scope.processing = false;
          });
      },
      createAlert(msg, type) {
        $scope.data.alerts = [];
        $scope.data.alerts.push({
          msg,
          type,
        });
      },
    };

    $scope.initialize();
  },
]);
